export default class Empresa{

    constructor(model = null){

        this.id = 0;
        this.nome = '';
        this.fantasia = '';
        this.cnpj = '';
        this.crm = '';
        this.insc_Estadual = '';
        this.insc_Municipal = '';
        this.cep = '';
        this.logradouro = '';
        this.bairro = '';
        this.cidade = '';
        this.estado = '';
        this.municipioId;
        this.pais = '';
        this.telefone1 = '';
        this.telefone2 = '';
        this.fax = '';
        this.email = '';
        this.responsavel = '';
        this.responsavel_Tel = '';
        this.responsavel_Email = '';
        this.vencimento = '';
        this.vencimentoBoleto = '';
        this.plano = '';
        this.planoStr = '';
        this.situacao = '';
        this.isJuridica = true;

        if(!model)
            return;

        this.id = model.id ? model.id : 0;
        this.nome = model.nome;
        this.fantasia = model.fantasia;
        this.cnpj = model.cnpj;
        this.crm = model.crm;
        this.insc_Estadual = model.insc_Estadual;
        this.insc_Municipal = model.insc_Municipal;
        this.cep = model.cep;
        this.logradouro = model.logradouro;
        this.bairro = model.bairro;
        this.cidade = model.cidade;
        this.estado = model.estado;
        this.municipioId = model.municipioId;
        this.pais = model.pais;
        this.telefone1 = model.telefone1;
        this.telefone2 = model.telefone2;
        this.fax = model.fax;
        this.email = model.email;
        this.responsavel = model.responsavel;
        this.responsavel_Tel = model.responsavel_Tel;
        this.responsavel_Email = model.responsavel_Email;
        this.vencimento = new Date(model.vencimento).yyyymmdd();
        this.vencimentoBoleto = model.vencimentoBoleto ? new Date(model.vencimentoBoleto).yyyymmdd() : '';
        this.plano = model.plano;
        this.planoStr = model.planoStr;
        this.situacao = model.situacao;
        this.isJuridica = model.isJuridica;
    }

}
